import { render, staticRenderFns } from "./InDmCardButton.vue?vue&type=template&id=50009740&scoped=true"
import script from "./InDmCardButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./InDmCardButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InDmCardButton.vue?vue&type=style&index=0&id=50009740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50009740",
  null
  
)

export default component.exports